export default __webpack_public_path__ + "static/media/user1.f407c3e5.jpg";